function formatToAUD(amount: any) {
  let formattedAmount = Number(amount).toLocaleString(undefined, { maximumFractionDigits: 2 });
  if (Number(amount) > 0 || Number(amount) === 0) {
    formattedAmount = "$" + formattedAmount;
  } else {
    formattedAmount = "-$" + formattedAmount.substring(1);
  }
  return formattedAmount;
}

  function intToStringShorten(number:any, onlyLetters: boolean) {
    number = number.toString().replace(/[^0-9.]/g, "");
    if( number == 0 ) {
      return "";
    }
    if (number < 1000) {
      if (onlyLetters) {
        return "";
      }
        return number;
    }
    let si = [
      {v: 1E3, s: "K"},
      {v: 1E6, s: "M"},
      {v: 1E9, s: "B"},
      {v: 1E12, s: "T"},
      {v: 1E15, s: "P"},
      {v: 1E18, s: "E"}
      ];
    let index;
    for (index = si.length - 1; index > 0; index--) {
        if (number >= si[index].v) {
            break;
        }
    }
    if (onlyLetters) {
      return si[index].s;
    } 
    return (number / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1");
}

// This is just to make sure the user can only input integers (and some basic other keyboard nav) when focused on
// a particular input field
export function checkIfNumber(event: any) {
  /**
   * Allowing: Integers | Backspace | Tab | Delete | Left & Right arrow keys
   **/

  const regex = new RegExp(/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/);
       
  return !event.key.match(regex) && event.preventDefault();
}

export function matchPriceFormat(numString: string): boolean {
  if (numString === "") {
    return false;
  }
  /**
   * Allowing: Integers | Backspace | Tab | Delete | Left & Right arrow keys
   **/

  const regex = new RegExp(/^\d*\.{0,1}\d*$/);

  const match = numString.match(regex);
       
  return (match && match.length > 0 && match[0] === numString) ?? false;
}

declare global {
  interface Number {
    formatAsPrice(round?: boolean, prependDollarSign?: boolean, showDecimals?: boolean): string;
  }
}

// Takes in a number and formats it as X.YY, where X can be any number of places but Y must be 2 decimal places, it is either truncated or padded with 0's to meet this requirement
/**
 * @param round - If true, the number will be rounded half away from zero - maintains consistency for reporting between freedom and the stores
 * @param prependDollarSign - If true, a dollar sign will be prepended to the number
 * @param showDecimals - If false, the string won't have any decimal places
 */
Number.prototype.formatAsPrice = function(round: boolean = false, prependDollarSign: boolean = false, showDecimals: boolean = true): string {
  if (isNaN(this.valueOf())) {
    return "";
  }
  let num = this;
  if (round) {
    // Round half away from zero
      var p = Math.pow(10, 2);
      var n = (num.valueOf() * p) * (1 + Number.EPSILON);
      num = Math.round(n) / p;
  }
  const floatString = num.toString();
  const stringSplit = floatString.split(".");
  let decimals = "";
  let integer = stringSplit[0] ?? "0";

  if (stringSplit[1]) {
    decimals = stringSplit[1].padEnd(2, "0"); // make sure decimals is at least places long
    decimals = decimals.substring(0, 2);
  } else {
    decimals = "".padEnd(2, "0");
  }

  // Splits up the integer so that we get thousands commas (eg. 1450492 => 1,450,492)
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Make sure the dollar sign appears at the front, unless the integer is negative
  let formattedString = "";
  if (integer.startsWith("-")) {
    formattedString = formattedString.concat("-");
    integer = integer.substring(1);
  }

  formattedString = formattedString.concat(prependDollarSign === true ? "$" : "");
  formattedString = formattedString.concat(integer);
  formattedString = formattedString.concat(showDecimals === true ? "." + decimals : "");

  return formattedString;
}

export { formatToAUD, intToStringShorten };